import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import callApi from "../../../../utility/apiCaller";
import Offercard from "./offercard";
import { toast } from "react-toastify";

const DMI_ID = "68ad8ed5078abf6c677e4303";
const DMI = "DMI";
const TOKEN = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJfaWQiOiI2OTAxYjljZjIxZTZlNTJmYTQwNDAwNDkiLCJvdHAiOiIxMTExIiwiY29udGFjdF9waG9uZSI6Ijk2OTMxMzU0NjYiLCJvdHBfZXhwaXJ5IjoiMjAyNS0xMC0yOVQwNzowMzowMy43MDZaIiwiaWF0IjoxNzYxNzIwNzg3fQ.xJ3Qd29aQPzV6vfc-bm5XDaOyIF1dXI4dD3lRZxEBDo"

const OfferPageAAFailed = () => {
  const [expandedId, setExpandedId] = useState(null);
  const aaSlice = useSelector((state) => state?.aa);
  const InternalLeadId = aaSlice?.internalLeadId;
  const [offers, setOffers] = useState([]);
  const dispatch = useDispatch();

  const fetchOffers = async (leadId, token) => {
    if (!leadId) return false;

    try {
      const res = await callApi(
        `v1/loan_offer/lead_id/${leadId}`,
        "get",
        {},
        "core",
        token
      );

      if (res.status === "Success" && res.data?.offers?.length > 0) {
        const lenderListRes = await callApi(
          `v1/lender_api_call/${leadId}/get-fail-success-lenders`,
          "post",
          {},
          "loan",
          token
        );

        let lenderMap = {};

        // if (Array.isArray(lenderListRes.data?.FailList)) {
        //   setFailedList(lenderListRes.data?.FailList);
        // }

        const failedList = lenderListRes.data?.FailList;

        if (
          lenderListRes.status === "Success" &&
          Array.isArray(lenderListRes.data?.Successlist)
        ) {
          lenderMap = Object.fromEntries(
            lenderListRes.data.Successlist.map((lender) => [
              lender.lender_id,
              lender,
            ])
          );
        }

        const enrichedOffers = offers.map((offer) => {
          const lender = lenderMap[offer.lender_id] || {};

          return {
            ...offer,
            apr: lender.apr ?? "",
            kfs_doc: lender.kfs_doc ?? "",
            credit_limit: lender.web_offer ?? "",
            penal_charges: lender.penal_charges ?? "",
            processing_fee: lender.processing_fee ?? "",
            interest_rate: lender.web_interest ?? null,
            lender_name: lender.lender_name ?? offer.lender_name,
          };
        });
        const filteredOffers = enrichedOffers.filter(
          (o) => o.lender_name !== DMI || o.lender_id !== DMI_ID
        );
        setOffers(filteredOffers);

        return {
          success: true,
          offers: enrichedOffers,
          failedList: failedList,
        };
      }

      return { success: false, offers: [] };
    } catch (err) {
      console.error("Error in offer fetching", err);
      toast.error("Something went wrong while fetching offers.");

      return { success: false, offers: [] };
    }
  };

  useEffect(() => {
    fetchOffers(InternalLeadId, TOKEN);
  }, []);

  const handleExpand = (id) => {
    setExpandedId(expandedId === id ? null : id);
  };

  return (
    <div className=" w-full max-w-[400px] mx-auto min-h-screen bg-[#004739] text-white  flex flex-col items-center">
      {/* Header */}
      <div className="w-full max-w-md text-center px-2 pt-4 pb-5 rounded-b-[50px] bg-white">
        <div className="flex justify-between w-full items-center mb-8">
          <img
            src="/assets/img/Footer logo.png"
            alt="digitmoney logo"
            className="h-[17px] w-[100px]"
          />
          <img
            src="/assets/img/dmiicon.png"
            alt="DMI Finance logo"
            className="h-[32px] w-[123px]"
          />
        </div>

        <div className=" text-black  rounded-xl mt-6">
          <img
            src="/assets/img/Layer_1 (46).png"
            className="w-[117px] h-[117px] mx-auto object-cover"
            alt="snail"
          />
          <p className="mt-4 text-[14px] leading-[18px] font-atkinson">
            We regret to inform you that your application <br /> with{" "}
            <span className="font-atkinson-bold">DMI Finance</span> cannot be
            processed. You <br /> may explore other eligible offers
          </p>
        </div>
      </div>

      {/* Title */}
      {offers.length > 0 && <div className="text-center">
        <h2 className="text-[35px] text-[#12F280] font-bomstad-bold mt-10">
          Don't Worry!!
        </h2>
        <p className="text-[18px] leading-[20px] tracking-wider  my-3 font-bomstad-thin text-center">
          We've Found Alternative Offers <br /> That Fit Your Profile
        </p>

      </div>}
      {/* Offer List */}
      <div className="w-full max-w-md space-y-4 mt-2 px-4">
        {offers.map((offer) => (
          <Offercard
            key={offer._id}
            offer={offer}
            isExpanded={expandedId === offer._id}
            onExpand={() => handleExpand(offer._id)}
          />
        ))}
      </div>

      {/* Footer Note */}
      <div className="px-5 py-4 gap-3 flex flex-col ">
        {offers.length > 0 && <p className="text-center font-bomstad-bold  text-[15px] leading-[1] text-[#00B894] ">
          Choose from these incredible offers that best suit your needs
        </p>}
        <p className="text-xs opacity-60 text-center max-w-md mt-6">
          *These pre-approved offers are subject to change at discretion of Bank
          / NBFC after receiving all your documents and details. Final offer
          will be based on risk policy of Bank / NBFC. We do not guarantee that
          final offer will be same as Pre-approved offer.
        </p>
      </div>
    </div>
  );
};

export default OfferPageAAFailed;
